// extracted by mini-css-extract-plugin
export default {"content":"gymblock_content__80QZh","gridContainer":"gymblock_gridContainer__ESE0F"};